// Упомянут ли email в тексте как «@email». Проверка та же, что на бэкенде
// (подстрока без учёта регистра): отметка упоминания должна совпадать с пушем
// об упоминании, в том числе со знаком препинания после адреса.
export default function mentionedEmail(email, message) {
  if (!email || typeof message !== "string") return false;
  return message.toLowerCase().includes("@" + email.toLowerCase());
}
